import * as React from 'react';
import { forwardRef } from 'react';

export type DMIframeProps = React.IframeHTMLAttributes<HTMLIFrameElement>;

export const DMIframe = forwardRef<HTMLIFrameElement, DMIframeProps>(
  ({ className = '', title = 'Embedded content', ...props }, ref) => {
    return <iframe ref={ref} className={className} title={title} {...props} />;
  }
);
DMIframe.displayName = 'DMIframe';
